import { Injectable } from '@angular/core';
import { ComponentLocationStrategy } from './component-location-strategy';

@Injectable()
export class PersonGbDetailLocationStrategy extends ComponentLocationStrategy {
  constructor() {
    super();
  }

  componentId(): string {
    return 'PERSONGB_ROLLE';
  }
}
